import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['input']

  connect() {
    this.handleInputs()
  }

  change(event) {
    this.handleInputs()
  }

  handleInputs() {
    this.inputTargets.forEach((input) => {
      this.handle(input)
    })
  }

  handle(input) {
    const targetId = input.dataset.revealTarget
    const target = document.getElementById(targetId)
    if (!target) {
      return
    }

    console.log("hello")

    if (input.checked) {
      target.classList.remove('hidden')
    } else {
      target.classList.add('hidden')
    }
  }
}
